import React from 'react';
import { useNode } from '@craftjs/core';
import { useTheme } from '../../../contexts/ThemeContext';

// Canvas component that holds all the blocks - the root container
export const Canvas = ({ children }) => {
  const { isDark } = useTheme();
  const { connectors: { connect } } = useNode();

  return (
    <div
      ref={connect}
      className={`min-h-[500px] p-6 rounded-lg ${
        isDark ? 'bg-zinc-900/30' : 'bg-white'
      }`}
    >
      {children}
    </div>
  );
};

Canvas.craft = {
  displayName: 'Canvas',
  rules: {
    canMoveIn: () => true,
    canDrag: () => false,
    canMoveOut: () => false
  }
};

export default Canvas;
